import { Directive, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { TaskService } from '../services/task-service';

@Directive()
export abstract class BaseTask implements OnInit, OnDestroy {
  isLoading = signal(true);
  isProcessing = signal<boolean>(false);
  pendingTasks = signal<any[]>([]);

  private eventSubscription?: Subscription;

  protected readonly taskService = inject(TaskService);

  abstract loadData(): void;
  abstract onTaskEventTriggered(): void;

  ngOnInit() {
    this.loadData();

    this.eventSubscription = this.taskService.getTaskEvents().subscribe((event: any) => {
      if (event?.type === 'active' || event?.type === 'waiting') {
        this.isProcessing.set(true);
      } else if (event?.type === 'progress') {
        const currentTasks = [...this.pendingTasks()];
        const targetTask = currentTasks.find((t) => t.id === event.jobId || t.data?.taskId === event.taskId);
        if (targetTask) {
          targetTask.progress = event.progress ?? event.percent;
          targetTask.step = event.step;
          targetTask.progressMessage = event.message;
          this.pendingTasks.set(currentTasks);
        }
      } else if (event?.type === 'completed' || event?.type === 'error' || event?.type === 'cancelled') {
        this.loadData();
      }
      this.onTaskEventTriggered();
    });
  }

  ngOnDestroy() {
    this.unsubscribeFromEvents();
  }

  private unsubscribeFromEvents() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  getPendingTask(indexName: string, type: 'DOCUMENT_INGESTION' | 'WEB_CRAWL') {
    this.taskService.getQueuedTasks(indexName, type).subscribe((response) => {
      if (response.length > 0) {
        this.isProcessing.set(true);
      } else {
        this.isProcessing.set(false);
      }

      if (this.pendingTasks().length && !response.length) {
        this.loadData();
      }

      this.pendingTasks.set(response);
    });
  }
}